import React from "react";
import { useSummary } from "../../lib/varSummary";

const DBMeta = () => {
    const { summary } = useSummary();
    return (
        <div className="main">
            <h4>Genres</h4>
            <ul>
                { summary.genres ?
                    Object.keys(summary.genres).map((i, j) => (
                        <li key={i}>{i}: {summary.genres[i]}</li>
                    ))
                : null}
            </ul>
        </div>
    )
}

export default DBMeta